import { SVGProps } from 'react';

const Engineering = ({
  props,
  fill = 'currentColor',
  size = 24,
}: {
  props?: SVGProps<SVGSVGElement>;
  fill?: string;
  size?: string | number;
}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fill={fill}
      d="M10 2.25a.75.75 0 0 1 .75.75v1.25H13a.75.75 0 0 1 0 1.5H6a.25.25 0 0 0-.25.25v12a.25.25 0 0 0 .25.25h12a.25.25 0 0 0 .25-.25v-7a.75.75 0 0 1 1.5 0v2.25H21a.75.75 0 0 1 0 1.5h-1.25V18A1.75 1.75 0 0 1 18 19.75h-3.25V21a.75.75 0 0 1-1.5 0v-1.25h-2.5V21a.75.75 0 0 1-1.5 0v-1.25H6A1.75 1.75 0 0 1 4.25 18v-3.25H3a.75.75 0 0 1 0-1.5h1.25v-2.5H3a.75.75 0 0 1 0-1.5h1.25V6A1.75 1.75 0 0 1 6 4.25h3.25V3a.75.75 0 0 1 .75-.75m5 6a.75.75 0 0 1 .75.75v6a.75.75 0 0 1-.75.75H9a.75.75 0 0 1-.75-.75V9A.75.75 0 0 1 9 8.25zm-5.25 6h4.5v-4.5h-4.5zm9.25-12a.75.75 0 0 1 .75.75A1.25 1.25 0 0 0 21 4.25a.75.75 0 0 1 0 1.5A1.25 1.25 0 0 0 19.75 7a.75.75 0 0 1-1.5 0A1.25 1.25 0 0 0 17 5.75a.75.75 0 0 1 0-1.5A1.25 1.25 0 0 0 18.25 3a.75.75 0 0 1 .75-.75"
    />
  </svg>
);

export default Engineering;
